import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c7890ec3f8480013558847/saraswathischool_1774684430871/src/app/admin-panel/page.tsx");
